import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { getData, postFile, deleteFile, getFile } from "features/dinamic";
import { setLoading } from "features/loader";
import { setVisible, setVisibleSecondary } from "features/modal";
import { setDataToast, setVisibleToast } from "features/toast";
import AlertInterface from "features/toast/toastInterface";
import saveAs from "file-saver";

interface AlumnoEntregaState {
  status: string;
  error: string;
  tareaContext: any | null;
  tareaEntrega: any | null;
  entregaContext: any | null;
}

const initialState: AlumnoEntregaState = {
  status: 'idle',
  error: '',
  tareaContext: null,
  tareaEntrega: null,
  entregaContext: null,
}

export const fetchTareaContext = createAsyncThunk('alumno/fetchTareaContext', async ({ idTareaSesion }: any, { dispatch, getState, rejectWithValue }) => {
  const idsp = 210;
  const { result, message, data } = await getData({ idsp, idTareaSesion }, getState, dispatch);
  if (result) {
    return { data };
  }
  return rejectWithValue(message);
});

export const fetchTareaEntrega = createAsyncThunk('alumno/fetchTareaEntrega', async ({ idTareaSesion }: any, { dispatch, getState, rejectWithValue }) => {
  const idsp = 211;
  const { result, message, data } = await getData({ idsp, idTareaSesion }, getState, dispatch);
  if (result) {
    return { data };
  }
  return rejectWithValue(message);
});

export const fetchEntregaContext = createAsyncThunk('alumno/fetchEntregaContext', async ({ idTareaAlumno }: any, { dispatch, getState, rejectWithValue }) => {
  const idsp = 216;
  const { result, message, data } = await getData({ idsp, idTareaAlumno }, getState, dispatch);
  if (result) {
    return { data };
  }
  return rejectWithValue(message);
});

export const saveEntregaTarea = createAsyncThunk('alumno/saveEntregaTarea', async (_: any, { dispatch, getState, rejectWithValue }) => {
  const state: any = getState();
  const entrega = selectTareaEntrega(state);

  const idsp = 212;
  const { result, message, data } = await getData({
    idsp,
    idTareaSesion: entrega.idTareaSesion,
    urlArchivo: entrega.urlArchivo,
    nombreArchivo: entrega.nombreArchivo,
    observaciones: entrega.observaciones
  }, getState, dispatch);

  if (result) {
    let alert: AlertInterface = {
      title: 'CORRECTO..!',
      message: message || "ENTREGA GUARDADA CORRECTAMENTE",
      data: [],
      type: 'LimeGreen',
      time: Date.now()
    };
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    dispatch(setVisible(false));
    dispatch(setVisibleSecondary(false));
    dispatch(setLoading(false));
    setTimeout(() => {
      dispatch(setVisibleToast(false));
    }, 4000);
    return { data };
  }
  return rejectWithValue(message);
});

export const uploadEntregaFile = createAsyncThunk('alumno/uploadEntregaFile', async (_: any, { dispatch, getState, rejectWithValue }) => {
  const state: any = getState();
  const entrega = selectTareaEntrega(state);

  if (!entrega.fileData || !entrega.idTareaAlumno) {
    return rejectWithValue('Archivo o ID de entrega requerido');
  }

  const idsp = 213; // PA_FILE_TAREA_ALUMNO
  const timestamp = Date.now();
  const fileName = `${entrega.idTareaAlumno}_${timestamp}`;
  const formData = new FormData();
  formData.append('dir', 'tarea');
  formData.append('idsp', idsp.toString());
  formData.append('id', entrega.idTareaAlumno.toString());
  formData.append('fileName', fileName);
  formData.append('fileData', entrega.fileData);

  const { result, message, data } = await postFile(formData, getState, dispatch);

  if (result) {
    let alert: AlertInterface = {
      title: 'CORRECTO..!',
      message: message || "ARCHIVO SUBIDO CORRECTAMENTE",
      data: [],
      type: 'LimeGreen',
      time: Date.now()
    };
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    dispatch(setLoading(false));
    setTimeout(() => {
      dispatch(setVisibleToast(false));
    }, 4000);
    return { data };
  }
  return rejectWithValue(message);
});

export const deleteEntregaTarea = createAsyncThunk('alumno/deleteEntregaTarea', async (_: any, { dispatch, getState, rejectWithValue }) => {
  const state: any = getState();
  const entrega = selectTareaEntrega(state);

  const idsp = 214; 
  const { result, message, data } = await getData({
    idsp,
    idTareaAlumno: entrega.idTareaAlumno
  }, getState, dispatch);

  if (result) {
    if (data?.fileUrl) {
      await deleteFile([{ fileUrl: data.fileUrl }], getState, dispatch);
    }

    let alert: AlertInterface = {
      title: 'CORRECTO..!',
      message: message || "ENTREGA ELIMINADA CORRECTAMENTE",
      data: [],
      type: 'LimeGreen',
      time: Date.now()
    };
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    dispatch(setVisible(false));
    dispatch(setVisibleSecondary(false));
    dispatch(setLoading(false));
    setTimeout(() => {
      dispatch(setVisibleToast(false));
    }, 4000);
    return { data };
  }
  return rejectWithValue(message);
});

export const downloadActividad = createAsyncThunk('alumno/downloadActividad', async ({ fileUrl, fileName }: any, { dispatch, getState, rejectWithValue }) => {
  let alert: AlertInterface;

  if (fileUrl) {
    const fileExtension = fileUrl.substring(fileUrl.lastIndexOf('.'));
    const fullFileName = `${fileName}${fileExtension}`;
    const response = await getFile({ fileUrl: fileUrl, fileName: fullFileName });

    if (response && response.blob) {
      saveAs(response.blob, fullFileName);
      alert = { title: 'CORRECTO..!', message: "ARCHIVO DESCARGADO CORRECTAMENTE", data: [], type: 'LimeGreen', time: Date.now() };
    } else {
      alert = { title: 'ACCIÓN INCOMPLETA', message: "ARCHIVO NO DISPONIBLE", data: [], type: 'Crimson', time: Date.now() };
    }
  } else {
    alert = { title: 'ACCIÓN INCOMPLETA', message: "ARCHIVO NO DISPONIBLE", data: [], type: 'Crimson', time: Date.now() };
  }

  dispatch(setDataToast(alert));
  dispatch(setVisibleToast(true));
  dispatch(setLoading(false));
  setTimeout(() => {
    dispatch(setVisibleToast(false));
  }, 4000);
});

export const downloadEntrega = createAsyncThunk('alumno/downloadEntrega', async ({ fileUrl, fileName }: any, { dispatch, getState, rejectWithValue }) => {
  let alert: AlertInterface;

  if (fileUrl) {
    const fileExtension = fileUrl.substring(fileUrl.lastIndexOf('.'));
    const fullFileName = `${fileName}${fileExtension}`;
    const response = await getFile({ fileUrl: fileUrl, fileName: fullFileName });

    if (response && response.blob) {
      saveAs(response.blob, fullFileName);
      alert = { title: 'CORRECTO..!', message: "ARCHIVO DESCARGADO CORRECTAMENTE", data: [], type: 'LimeGreen', time: Date.now() };
    } else {
      alert = { title: 'ACCIÓN INCOMPLETA', message: "ARCHIVO NO DISPONIBLE", data: [], type: 'Crimson', time: Date.now() };
    }
  } else {
    alert = { title: 'ACCIÓN INCOMPLETA', message: "ARCHIVO NO DISPONIBLE", data: [], type: 'Crimson', time: Date.now() };
  }

  dispatch(setDataToast(alert));
  dispatch(setVisibleToast(true));
  dispatch(setLoading(false));
  setTimeout(() => {
    dispatch(setVisibleToast(false));
  }, 4000);
});

const alumnoEntregaSlice = createSlice({
  name: 'alumnoEntrega',
  initialState,
  reducers: {
    setTareaContext: (state, action) => {
      state.tareaContext = action.payload;
    },
    setTareaEntrega: (state, action) => {
      state.tareaEntrega = action.payload;
    },
    setEntregaContext: (state, action) => {
      state.entregaContext = action.payload;
    },
    clearEntregaData: (state) => {
      state.tareaContext = null;
      state.tareaEntrega = null;
      state.entregaContext = null;
    },
    clearAlumnoEntrega: () => initialState,
  },
  extraReducers(builder) {
    builder
      .addCase(fetchTareaContext.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchTareaContext.fulfilled, (state, action) => {
        state.status = 'completed';
        const data = action.payload?.data;
        state.tareaContext = Array.isArray(data) ? data[0] : data;
      })
      .addCase(fetchTareaContext.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as string;
      })
      .addCase(fetchTareaEntrega.fulfilled, (state, action) => {
        const data = action.payload?.data;
        state.tareaEntrega = Array.isArray(data) ? data[0] : data;
      })
      .addCase(fetchEntregaContext.fulfilled, (state, action) => {
        const data = action.payload?.data;
        state.entregaContext = Array.isArray(data) ? data[0] : data;
      })
      .addCase(saveEntregaTarea.fulfilled, (state, action) => {
        if (action.payload?.data) {
          state.tareaEntrega = { ...state.tareaEntrega, ...action.payload.data };
        }
      })
      .addCase(deleteEntregaTarea.fulfilled, (state) => {
        state.tareaEntrega = null;
      })
  }
});

export const selectTareaContext = (state: RootState) => state.alumnoEntrega.tareaContext;
export const selectTareaEntrega = (state: RootState) => state.alumnoEntrega.tareaEntrega;
export const selectEntregaContext = (state: RootState) => state.alumnoEntrega.entregaContext;
export const selectEntregaStatus = (state: RootState) => state.alumnoEntrega.status;

export const { setTareaContext, setTareaEntrega, setEntregaContext, clearEntregaData, clearAlumnoEntrega } = alumnoEntregaSlice.actions;

export default alumnoEntregaSlice.reducer;